import React from 'react';

import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import Typography from '@mui/material/Typography';

import styled from 'styled-components';

import { fonts } from '../gatsby-theme-material-ui-top-layout/theme';

import {
  PROPY_SPACE_GREY_LIGHT,
  PROPY_BLACK,
  PROPY_LIGHTER_GREY,
} from '../utils';

const ZoneContainer = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Zone = styled.div`
  max-width: 1080px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`

const TypographyContainer = styled.div`
  max-width: ${props => props.mobile ? '300px' : 'none'};
  margin-left: ${props => props.mobile ? 'auto' : '0px'};
  margin-right: ${props => props.mobile ? 'auto' : '0px'};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: ${props => props.mobile ? 'center' : 'start'};
  width: 100%;
`

const TypographySpacer = styled.div`
  margin-top: ${props => props.theme.spacing(1.5)};
`

const InvestorsContainer = styled.div`
  margin-top: ${props => props.theme.spacing(4)};
  display: flex;
  justify-content: space-between;
  overflow-x: ${props => props.mobile ? 'scroll' : 'visible'};
  padding-left: ${props => props.mobile ? props.theme.spacing(2) : '0px'};
  padding-right: ${props => props.mobile ? props.theme.spacing(2) : '0px'};
  padding-bottom: ${props => props.mobile ? props.theme.spacing(2) : '0px'};
`

const InvestorBlock = styled.div`
  margin-top: ${props => props.theme.spacing(4)};
  margin-right: ${props => props.theme.spacing(4)};
  display: flex;
  flex-direction: column;
  text-align: center;
`

const InvestorImageContainer = styled.div`
  width: 150px;
  height: 150px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: ${props => props.theme.spacing(2)};
`

const individuals = [
  {
    name: "Tim Draper",
    positions: ["Venture Capitalist"],
  },
  {
    name: "MICHAEL PIWOWAR",
    positions: ["Former Chairman SEC", "MILKEN INSTITUTE"],
  },
  {
    name: "Adriana Cisneros",
    positions: ["Coral Ventures"],
  },
  {
    name: "MICHAEL CASEY",
    positions: ["CoinDesk, WSJ", "DAIS ADVISOR", "MIT MEDIA LAB"],
  },
  {
    name: "Jake Bruckman",
    positions: ["COINFUND"],
  }
];

const Investors = ({ isConsideredMobile }) => {

  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativePath: { regex: "/^investors-\\d+/" }
        }
        sort: { fields: relativePath }
      ) {
        edges {
          node {
            relativePath
            childImageSharp {
              gatsbyImageData(
                width: 150
                height: 150
                transformOptions: {
                  fit: COVER
                  cropFocus: CENTER
                }
                placeholder: BLURRED
                layout: FIXED
                quality: 100
              )
            }
          }
        }
      }
    }
  `);

  const imageMap = data.allFile.edges.reduce((acc, { node }, index) => {
    acc[index] = getImage(node);
    return acc;
  }, {});

  const individualsWithGatsbyImages = individuals.map((individual, index) => ({
    ...individual,
    gatsbyImage: imageMap[index]
  }));

  return (
    <ZoneContainer>
      <Zone>
        <TypographyContainer mobile={isConsideredMobile}>
          <Typography sx={{ fontFamily: fonts.spaceGrotesk, color: PROPY_SPACE_GREY_LIGHT, letterSpacing: '0.12em', textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '14px', lineHeight: '14px' }) }}>
            INVESTORS & ADVISERS
          </Typography>
          <TypographySpacer>
            <Typography variant="h4" sx={{ fontFamily: fonts.spaceGrotesk, color: PROPY_BLACK, letterSpacing: '-0.01em', textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '24px', lineHeight: '24px' }) }}>
              Our investors and advisers are some of the smartest people in real estate, technology and investment.
            </Typography>
          </TypographySpacer>
        </TypographyContainer>
        <InvestorsContainer mobile={isConsideredMobile}>
          {individualsWithGatsbyImages.map((individual, index) => 
            <InvestorBlock
              key={`individual-investor-${index}`}
            >
              <InvestorImageContainer>
                <GatsbyImage
                  image={individual.gatsbyImage}
                  alt={individual.name}
                  style={{
                    width: '100%',
                    height: '100%',
                  }}
                />
              </InvestorImageContainer>
              <div>
                <Typography style={{color: PROPY_BLACK, letterSpacing: '0.04em', fontWeight: 500, lineHeight: '15px', fontSize: '14px', textTransform: 'uppercase'}} sx={{ fontFamily: fonts.spaceGrotesk }}>
                  {individual.name}
                </Typography>
                {individual.positions.map((position, posIndex) => 
                  <Typography 
                    key={`position-${index}-${posIndex}`}
                    style={{color: PROPY_LIGHTER_GREY, letterSpacing: '0.04em', fontWeight: 400, lineHeight: '15px', fontSize: '14px',  textTransform: 'uppercase'}} 
                    sx={{ fontFamily: fonts.spaceGrotesk }}
                  >
                    {position}
                  </Typography>
                )}
              </div>
            </InvestorBlock>
          )}
        </InvestorsContainer>
      </Zone>
    </ZoneContainer>
  );
};

export default Investors;